import {
    shop_types_request_invalid,
    shop_types_request_send,
    shop_types_request_valid,
} from './../actions/getTypes';
import {
    shop_list_request_invalid,
    shop_list_request_send,
    shop_list_request_valid,
    shop_select_type,
} from './../actions/getList';
import {
    constInitialState,
    constInvalid,
    constSend,
    constValid,
} from './../../../constants';
import _ from 'underscore';
import { order_store_request_valid } from '../../order/actions/store';
import { Float } from '../../../functions/input-float';
import {
    shop_search_list_request_invalid,
    shop_search_list_request_send,
    shop_search_list_request_valid,
} from '../actions/getListSearch';
import { close_product_modal, open_product_modal } from '../actions/setModal';
import {
    shop_new_products_request_invalid,
    shop_new_products_request_send,
    shop_new_products_request_valid,
} from 'app/modules/shop/actions/getNewProducts';
import {
    shop_popular_products_request_invalid,
    shop_popular_products_request_send,
    shop_popular_products_request_valid,
} from 'app/modules/shop/actions/getPopularProducts';

const initialStateShopCase = () => ({
    products: [],
});

const initialStateOrder = () => ({
    first_name: '',
    email: '',
    phone: '',
    delivery: 1,
    addresses: [],
    comments: [],
    payment_type: 0,
});

const initialState = {
    active_type: null,
    productModal: null,
    productsSearch: constInitialState(),
    types: constInitialState(),
    list: constInitialState(),
    shopCase: initialStateShopCase(),
    newProducts: constInitialState(),
    popularProducts: constInitialState(),
    order: initialStateOrder(),
};
export const shopReducer = function (state = initialState, action) {
    switch (action.type) {
        case shop_new_products_request_invalid: {
            return {
                ...state,
                newProducts: {
                    ...state.newProducts,
                    ...constInvalid(),
                },
            };
        }
        case shop_new_products_request_send: {
            return {
                ...state,
                newProducts: {
                    ...state.newProducts,
                    ...constSend(),
                },
            };
        }
        case shop_new_products_request_valid: {
            return {
                ...state,
                newProducts: {
                    ...action.data,
                },
            };
        }
        case shop_popular_products_request_invalid: {
            return {
                ...state,
                popularProducts: {
                    ...state.popularProducts,
                    ...constInvalid(),
                },
            };
        }
        case shop_popular_products_request_send: {
            return {
                ...state,
                popularProducts: {
                    ...state.popularProducts,
                    ...constSend(),
                },
            };
        }
        case shop_popular_products_request_valid: {
            return {
                ...state,
                popularProducts: {
                    ...action.data,
                },
            };
        }
        case shop_select_type: {
            return {
                ...state,
                active_type: Number(action.data.type),
                children: action.data.children || [],
            };
        }
        case order_store_request_valid: {
            return {
                ...state,
                shopCase: {
                    ...initialStateShopCase(),
                },
            };
        }
        case shop_types_request_invalid: {
            return {
                ...state,
                types: {
                    ...state.types,
                    ...constInvalid(),
                },
            };
        }
        case shop_types_request_send: {
            return {
                ...state,
                types: {
                    ...state.types,
                    ...constSend(),
                },
            };
        }
        case shop_types_request_valid: {
            return {
                ...state,
                types: {
                    ...state.types,
                    ...constValid(),
                    response: {
                        ...state.types.response,
                        lists:
                            action.data && action.data.types
                                ? action.data.types
                                : [],
                    },
                },
            };
        }
        case shop_list_request_invalid: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...constInvalid(),
                },
            };
        }
        case shop_list_request_send: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...constSend(),
                },
            };
        }
        case shop_list_request_valid: {
            return {
                ...state,
                list: {
                    ...state.list,
                    ...constValid(),
                    response: action.data || {},
                },
            };
        }
        case shop_search_list_request_invalid: {
            return {
                ...state,
                productsSearch: {
                    ...state.productsSearch,
                    ...constInvalid(),
                },
            };
        }
        case shop_search_list_request_send: {
            return {
                ...state,
                productsSearch: {
                    ...state.productsSearch,
                    ...constSend(),
                },
            };
        }
        case shop_search_list_request_valid: {
            return {
                ...state,
                productsSearch: {
                    ...state.productsSearch,
                    response: action.data,
                    ...constValid(),
                },
            };
        }
        case 'add_product': {
            let product = { ...action.product },
                product_id = product.id,
                products = [...state.shopCase.products],
                product_index = _.findIndex(
                    products,
                    (i) => i.id === product_id
                );

            if (product_index !== -1)
                products[product_index] = {
                    ...products[product_index],
                    qty: Number(products[product_index].qty) + 1,
                };
            else
                products = [
                    {
                        ...product,
                        qty: 1,
                    },
                ].concat(products);

            return {
                ...state,
                shopCase: {
                    ...state.shopCase,
                    products: [...products],
                },
            };
        }
        case 'remove_product': {
            let product = { ...action.product },
                product_id = product.id,
                products = [...state.shopCase.products],
                product_index = _.findIndex(
                    products,
                    (i) => i.id === product_id
                );

            if (product_index !== -1)
                products[product_index] = {
                    ...products[product_index],
                    qty:
                        products[product_index].qty > 0
                            ? Number(products[product_index].qty) - 1
                            : 0,
                };
            else
                products = [
                    {
                        ...product,
                        qty: 1,
                    },
                ].concat(products);

            return {
                ...state,
                shopCase: {
                    ...state.shopCase,
                    products: [...products],
                },
            };
        }
        case 'set_product_qty': {
            let product_id = action.product_id,
                qty = Number(Float(action.qty, 3)),
                products = [...state.shopCase.products],
                product_index = _.findIndex(
                    products,
                    (i) => i.id === product_id
                );

            if (product_index !== -1)
                products[product_index] = {
                    ...products[product_index],
                    qty: qty,
                };

            return {
                ...state,
                shopCase: {
                    ...state.shopCase,
                    products: products,
                },
            };
        }
        case 'set_product_qty_with_product': {
            let product_id = action.product_id,
                product = action.product,
                qty = Number(Float(action.qty, 3)),
                products = [...state.shopCase.products],
                product_index = _.findIndex(
                    products,
                    (i) => i.id === product_id
                );

            if (product_index !== -1) {
                products[product_index] = {
                    ...products[product_index],
                    qty: qty,
                };
                if (qty === 0) products.splice(product_index, 1);
            } else {
                products = [
                    {
                        ...product,
                        qty: qty,
                    },
                ].concat(products);
            }
            return {
                ...state,
                shopCase: {
                    ...state.shopCase,
                    products: products,
                },
            };
        }
        case 'destroy_product': {
            let product_id = action.product_id,
                products = [...state.shopCase.products],
                product_index = _.findIndex(
                    products,
                    (i) => i.id === product_id
                );

            if (product_index !== -1) products.splice(product_index, 1);

            return {
                ...state,
                shopCase: {
                    ...state.shopCase,
                    products: products,
                },
            };
        }
        case 'clear_shop_case': {
            return {
                ...state,
                shopCase: initialStateShopCase(),
            };
        }
        case 'set_order_data': {
            let order = { ...state.order };
            if (order.hasOwnProperty(action.nameInput)) {
                order[action.nameInput] = action.value;
            }
            return {
                ...state,
                order: order,
            };
        }
        case 'set_shop_point': {
            const { data: point } = action;

            localStorage.setItem('pointId', JSON.stringify(point.id));

            return {
                ...state,
                order: {
                    ...state.order,
                    point: {
                        ...point,
                    },
                },
            };
        }
        case open_product_modal: {
            return {
                ...state,
                productModal: action.data,
            };
        }
        case close_product_modal: {
            return {
                ...state,
                productModal: null,
            };
        }
        default:
            return state;
    }
};
